/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

const DescriptionBox = ({ content: { title, paragraphs, backgroundImage } }) => {
  const renderParagraphsWithSeparator = () => paragraphs.map((paragraph, index) => {
    const paraEl = <p key={`el-${index}`}>{paragraph}</p>;
    const hrEl = <hr key={`hr-${index}`} className="description-box-part description-box-divider" />;

    if (index === 0) return [paraEl];

    return [hrEl, paraEl];
  });

  const getBackgroundImageStyle = (url) => {
    if (!url) return {};

    return { backgroundImage: `url(${url})` };
  };

  const boxClassNames = `description-box${backgroundImage ? ' with-icon' : ''}`;

  return (
    <div
      className={boxClassNames}
      style={getBackgroundImageStyle(backgroundImage)}
    >
      <h4>{title}</h4>
      <div className="mini-divider-container">
        <hr className="mini-divider stick-left" />
      </div>
      { renderParagraphsWithSeparator() }
    </div>
  );
};

const descriptionBoxContentType = PropTypes.exact({
  title: PropTypes.string.isRequired,
  paragraphs: PropTypes.arrayOf(PropTypes.string).isRequired,
  backgroundImage: PropTypes.string,
});

DescriptionBox.propTypes = {
  content: descriptionBoxContentType.isRequired,
};

export default DescriptionBox;
